import { registerPreAuthorizationsMasonryRenderers } from '@leagueplatform/pre-authorizations';

export const initMasonryRegistry = () => {
  // Register Custom Masonry Node Renderers here
  registerPreAuthorizationsMasonryRenderers({
    authorizations: 'ptth_authorizations',
    pagination: 'ptth_authorizations_pagination',
    details: 'ptth_authorization_details',
    learnMore: 'default',
    filtersDisplay: 'inline',
  });
};
